import {
  Typography,
  Form,
  Input,
  Row,
  Col,
  Table,
  TableColumnsType,
} from 'antd';
import { css } from '@emotion/react';
import { useEffect } from 'react';


type PriorityType = 'PROTEIN' | 'LIPID' | 'GLUCOSE';

type Priority = {
  type: PriorityType;
  MIN_PROTEIN_PERCENT?: string;
  MAX_PROTEIN_PERCENT?: string;
  MIN_LIPID_PERCENT?: string;
  MAX_LIPID_PERCENT?: string;
  MIN_GLUCOSE_PERCENT?: string;
  MAX_GLUCOSE_PERCENT?: string;
};


const { Title } = Typography;


type CalculationConditionsProps = {
  listResult?: ResultCalculateNutrition;
  selectedRowTargetProfile?: TargetProfileListNutritionalMenuCalculator | null;
  valueForm?: any | null;
};


export default function CalculationConditionsTable({ listResult, selectedRowTargetProfile, valueForm }: CalculationConditionsProps) {
  const [form] = Form.useForm();

  const nutrientMap = {
    PROTEIN: {
      label: 'Chất đạm',
      minKey: 'MIN_PROTEIN_PERCENT',
      maxKey: 'MAX_PROTEIN_PERCENT',
      value: listResult?.ENERGY_PROTEIN,
      className: 'textGreen',
    },
    LIPID: {
      label: 'Chất béo',
      minKey: 'MIN_LIPID_PERCENT',
      maxKey: 'MAX_LIPID_PERCENT',
      value: listResult?.ENERGY_LIPID,
      className: 'textRed',
    },
    GLUCOSE: {
      label: 'Chất bột đường',
      minKey: 'MIN_GLUCOSE_PERCENT',
      maxKey: 'MAX_GLUCOSE_PERCENT',
      value: listResult?.ENERGY_GLUCOSE,
      className: 'textGreen',
    },
  };

  useEffect(() => {
    form.setFieldsValue({
      object: selectedRowTargetProfile?.AGE_RANGE_DESCRIPTION,
      gender: selectedRowTargetProfile?.GENDER_NAME,
      weight: selectedRowTargetProfile?.PROFILE_WEIGHT_MAX,
      nutritionalZCore: selectedRowTargetProfile?.ZSCORE_DESCRIPTION,
      medicalCondition: selectedRowTargetProfile?.HEALTH_STATUS_NAME,
      activity: selectedRowTargetProfile?.ACTIVITY_VALUE,
    });
  }, [form, selectedRowTargetProfile]);

  const columns: TableColumnsType<any> = [
    {
      title: 'STT',
      render: (_, __, index) => index + 1,
      key: 'index',
    },
    {
      title: 'Tên món ăn',
      dataIndex: 'FOOD_NAME',
      key: 'FOOD_NAME',
      width: 200,
      fixed: 'left',
    },
    {
      title: 'Tên nguyên liệu',
      dataIndex: 'NAME',
      key: 'NAME',
      width: 100,
    },
    {
      title: 'Chất bột đường(g)',
      dataIndex: 'GLUCOSE',
      key: 'GLUCOSE',
      width: 200,
    },
    {
      title: 'Chất đạm(g)',
      dataIndex: 'PROTEIN',
      key: 'PROTEIN',
      width: 300,
    },
    {
      title: 'Chất béo(g)',
      dataIndex: 'LIPID',
      key: 'LIPID',
      width: 300,
    },
    {
      title: 'Kết quả định lượng(g)',
      dataIndex: 'quantifiedResult',
      key: 'quantifiedResult',
      width: 150,
    }
  ];

  return (
    <div css={rootStyles}>
      <div css={boxStyles}>

        <Form
          form={form}
          css={formStyles}
          layout="horizontal"
          labelCol={{ span: 12 }}
          wrapperCol={{ span: 12 }}
        >
          <Title className="result-title" level={5}>Kết quả tính toán</Title>
          {selectedRowTargetProfile && (
            <>
              <Row gutter={24} align='stretch'>
                <Col span={12} css={filterItem}>
                  <Form.Item
                    label='Đối tượng'
                    name='object'
                    css={customLabel}
                  >
                    <Input
                      readOnly
                      css={css`
                  border: none !important;
                  box-shadow: none !important;
                  background-color: transparent !important;
                  padding-left: 0;
                  cursor: default;
                `} />
                  </Form.Item>
                </Col>
                <Col span={12} css={filterItem}>
                  <Form.Item
                    label='Giới tính'
                    name='gender'
                    css={customLabel}
                  >
                    <Input
                      readOnly
                      css={css`
                    border: none !important;
                    box-shadow: none !important;
                    background-color: transparent !important;
                    padding-left: 0;
                    cursor: default;
                  `} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24} align='stretch'>
                <Col span={12} css={filterItem}>
                  <Form.Item
                    label='Cân nặng (kg)'
                    name='weight'
                    css={customLabel}

                  >
                    <Input
                      readOnly
                      css={css`
                  border: none !important;
                  box-shadow: none !important;
                  background-color: transparent !important;
                  padding-left: 0;
                  cursor: default;
                `} />
                  </Form.Item>
                </Col>
                <Col span={12} css={filterItem}>
                  <Form.Item
                    label='Tình trạng dinh dưỡng theo ZScore (Cân nặng theo tuổi)'
                    name='nutritionalZCore'
                    css={customLabel}
                  >
                    <Input
                      readOnly
                      css={css`
                  border: none !important;
                  box-shadow: none !important;
                  background-color: transparent !important;
                  padding-left: 0;
                  cursor: default;
                `} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24} align='stretch' className='finalRow'>
                <Col span={12} css={filterItem}>
                  <Form.Item
                    label='Tình trạng bệnh lý:'
                    name='medicalCondition'
                    css={customLabel}
                  >
                    <Input
                      readOnly
                      css={css`
                  border: none !important;
                  box-shadow: none !important;
                  background-color: transparent !important;
                  padding-left: 0;
                  cursor: default;
                `} value={'Đái tháo đường, Gút'} />
                  </Form.Item>
                </Col>
                <Col span={12} css={filterItem}>
                  <Form.Item
                    label='Hoạt động thể lực'
                    name='activity'
                    css={customLabel}
                  >
                    <Input
                      readOnly
                      css={css`
                  border: none !important;
                  box-shadow: none !important;
                  background-color: transparent !important;
                  padding-left: 0;
                  cursor: default;
                `} />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          {listResult && (
            <>
              <Row
                gutter={16}
                align='middle'
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '1rem'
                }}
              >
              </Row>
              <Row gutter={24}>
                <Col span={8}>
                  <strong>Kết quả</strong>
                </Col>
                <Col span={8}>
                  <strong>Mục tiêu</strong>
                </Col>
                <Col span={8}>
                  <strong>Thực tế</strong>
                </Col>
              </Row>

              <Row gutter={24} className='rowStyle'>
                <Col span={8}>
                  <span>Tổng Kcal</span>
                </Col>
                <Col span={8}>
                  <span>{valueForm.kcalMin} - {valueForm.kcalMax} kcal</span>
                </Col>
                <Col span={8}>
                  <span className='textGreen textBold'>{listResult.W_RESULT?.[0]} kcal</span>
                </Col>
              </Row>

              <Row gutter={24} className='rowStyle'>
                <Col span={24}>
                  <span>Tỉ lệ % PLG phân bổ theo bữa</span>
                </Col>
              </Row>

              <>
                {(
                  Object.keys(nutrientMap) as Array<keyof typeof nutrientMap>
                ).map((key) => {
                  const nutrient = nutrientMap[key];
                  const priority = valueForm?.priorities?.find(
                    (p: Priority) => p.type === key
                  );

                  const min = priority?.[nutrient.minKey as keyof Priority] ?? '0';
                  const max = priority?.[nutrient.maxKey as keyof Priority] ?? '0';
                  const value = nutrient.value ?? '-';

                  return (
                    <Row gutter={24} className="rowStyle" key={key}>
                      <Col span={8}>
                        <i>{nutrient.label}</i>
                      </Col>
                      <Col span={8}>
                        <span>
                          {min} - {max} %
                        </span>
                      </Col>
                      <Col span={8}>
                        <span className={nutrient.className}>{value}%</span>
                      </Col>
                    </Row>
                  );
                })}
              </>
              <div css={tableWrapper}>
                <Table<any>
                  columns={columns}
                  dataSource={listResult.NEW_INGREDIENTS}
                  pagination={false}
                />
              </div>
            </>
          ) || (
              <div className='noDataStyle'>
                Vui lòng chọn nguyên liệu và nhập các thông tin đầu vào cho bài toán<br /> và chọn nút "Tình toán dinh dưỡng" để tính toán
              </div>
            )}
        </Form>
      </div>
    </div>
  );
}


const rootStyles = css`
  background: var(--white-color);
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
  min-height: calc(100vh - var(--header-height));
`;

const boxStyles = css`
  padding: 0 1rem;
  background: var(--white-color);
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }

  .ant-row-stretch {
    align-items: center;
  }

  .ant-form-item-row {
    align-items: center;
  }

  .finalRow {
    margin-bottom: 4rem;
  }

  .rowStyle {
    margin-top: 0.5rem;
  }

  .textGreen {
    color: var(--success-color);
    font-weight: 700;
  }

  .textRed {
    color: var(--red-color);
    font-weight: 700;
  }

  .textBold {
    font-weight: bold;
  }

  .result-title {
    font-weight: 700;
    color: var(--blue-light-color);
  }

  .noDataStyle {
    text-align: center;
    font-weight: 400;
  }
`;

const formStyles = css`
  margin-top: 0.5rem;
  padding: 1rem;
`;

const filterItem = css`
  display: flex;
  justify-content: start !important;
  gap: 0.5rem;

  label {
    height: 100% !important;
  }

  .ant-form-item-label {
    width: fit-content;
    max-width: 33.33%;
    height: 100% !important;
    text-align: start !important;
    white-space: normal;
    font-size: 14px;
    font-weight: 500;
    word-wrap: break-word;
    word-break: break-word;
  }

  input,
  .ant-select,
  .ant-picker {
    flex: 1;
    min-width: 6rem;
  }

  .ant-form-item-control-input-content>.ant-input {
    height: auto !important;
    font-size: 14px !important;
  }

  .ant-form-item-control {
    justify-content: center !important
  }
`;

const customLabel = css`
  .ant-form-item-label > label {
    font-weight: normal !important;

    &::after,
    &::before {
      display: none !important;
    }
  }

  width: 100%;
  margin-bottom: 0;
`;

const tableWrapper = css`
  margin-top: 3rem;
`;